//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  name: 'Confirm',
  props: {
    show: {
      default: false,
      type: Boolean
    },
    title: {
      default: '',
      type: String
    },
    content: {
      default: '温馨提示',
      type: String
    },
    ok: {
      default: '确定',
      type: String
    }
  },
  methods: {
    onok () {
      this.$emit('onok')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dialog/Alert.vue